var React = require('react');

function Triangle1FormMobile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M68.357 89.1785L142.594 83.6328L65.0342 171.56L68.357 89.1785Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M37.3913 32.5486L142.647 83.7266L68.5042 89.2331L37.3913 32.5486Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M37.3906 32.5498L68.4817 89.1944L65.0339 171.559L37.3906 32.5498Z","fill":"#5915C7","key":2})]);
}

Triangle1FormMobile.defaultProps = {"width":"97","height":"172","viewBox":"0 0 97 172","fill":"none"};

module.exports = Triangle1FormMobile;

Triangle1FormMobile.default = Triangle1FormMobile;
